export const ADMIN_VIDEOS_REQUEST = 'ADMIN_VIDEOS_REQUEST'
export const ADMIN_VIDEOS_SUCCESS = 'ADMIN_VIDEOS_SUCCESS'
export const ADMIN_VIDEOS_FAIL = 'ADMIN_VIDEOS_FAIL'

export const ALL_VIDEOS_REQUEST = 'ALL_VIDEOS_REQUEST'
export const ALL_VIDEOS_SUCCESS = 'ALL_VIDEOS_SUCCESS'
export const ALL_VIDEOS_FAIL = 'ALL_VIDEOS_FAIL'

export const NEW_VIDEO_REQUEST = 'NEW_VIDEO_REQUEST'
export const NEW_VIDEO_SUCCESS = 'NEW_VIDEO_SUCCESS'
export const NEW_VIDEO_RESET = 'NEW_VIDEO_RESET'
export const NEW_VIDEO_FAIL = 'NEW_VIDEO_FAIL'

export const DELETE_VIDEO_REQUEST = 'DELETE_VIDEO_REQUEST'
export const DELETE_VIDEO_SUCCESS = 'DELETE_VIDEO_SUCCESS'
export const DELETE_VIDEO_RESET = 'DELETE_VIDEO_RESET'
export const DELETE_VIDEO_FAIL = 'DELETE_VIDEO_FAIL'

export const UPDATE_VIDEO_REQUEST = 'UPDATE_VIDEO_REQUEST'
export const UPDATE_VIDEO_SUCCESS = 'UPDATE_VIDEO_SUCCESS'
export const UPDATE_VIDEO_RESET = 'UPDATE_VIDEO_RESET'
export const UPDATE_VIDEO_FAIL = 'UPDATE_VIDEO_FAIL'

export const VIDEO_DETAILS_REQUEST = 'VIDEO_DETAILS_REQUEST'
export const VIDEO_DETAILS_SUCCESS = 'VIDEO_DETAILS_SUCCESS'
export const VIDEO_DETAILS_FAIL = 'VIDEO_DETAILS_FAIL'

export const NEW_REVIEW_REQUEST = 'NEW_REVIEW_REQUEST'
export const NEW_REVIEW_SUCCESS = 'NEW_REVIEW_SUCCESS'
export const NEW_REVIEW_RESET = 'NEW_REVIEW_RESET'
export const NEW_REVIEW_FAIL = 'NEW_REVIEW_FAIL'

export const GET_REVIEWS_REQUEST = 'GET_REVIEWS_REQUEST'
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS'
export const GET_REVIEWS_FAIL = 'GET_REVIEWS_FAIL'

export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_RESET = 'DELETE_REVIEW_RESET'
export const DELETE_REVIEW_FAIL = 'DELETE_REVIEW_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'